"use strict";
exports.__esModule = true;
exports.OperationalSubAccountList = void 0;
var SubAccountType_1 = require("../common/SubAccountType");
exports.OperationalSubAccountList = [
    SubAccountType_1.SubAccountType.forfeiture,
    SubAccountType_1.SubAccountType.spendingBudget,
    SubAccountType_1.SubAccountType.error,
    SubAccountType_1.SubAccountType.breakage,
    SubAccountType_1.SubAccountType.billing,
    SubAccountType_1.SubAccountType.dividend,
    SubAccountType_1.SubAccountType.moneyOut,
    SubAccountType_1.SubAccountType.moneyIn,
    SubAccountType_1.SubAccountType.suspense,
    SubAccountType_1.SubAccountType.settlement,
];
